import React from "react";

function Contact(){
return(

<section className="py-20 bg-gray-100 text-center" id="contact"  >

<h2 className="text-4xl font-bold mb-10">Contact Me</h2>

<form className="max-w-md mx-auto flex flex-col gap-4">

<input className="p-3 border rounded-lg" placeholder="Name"/>

<input className="p-3 border rounded-lg" placeholder="Email"/>

<textarea className="p-3 border rounded-lg" placeholder="Message"/>

<button className="bg-blue-500 text-white p-3 rounded-lg hover:bg-blue-600 transition">
Send Message
</button>

</form>

</section>

);
}

export default Contact;